module.exports = __webpack_public_path__ + "img/back-min.629aca12.png";